import * as React from 'react';
import { Form, Formik } from 'formik';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from '../../../../../../../consts/report';
import { getStartDateForSchoolYear } from '../../../../../../../helpers/calendar/calendar';
import { Team } from 'Src/models/team';
import {
  ReportActions,
  ReportDateRange,
  ReportDescription,
  ReportSection,
  ReportToggle,
  ReportToggleList
} from '../../../Events/SchoolEventView/Reports/ReportFormUi';
import '../../../Events/SchoolEventView/SchoolEventView.scss';

interface Props {
  onCloseClick: () => void;
  onSubmit: (data: any, reportType: string) => void;
  team: Team;
}

// report 027
export function TeamPerformanceReportForm(props: Props) {
  const now = new Date();
  let dateFrom = getStartDateForSchoolYear(now);
  const requestInitial = {
    dateFrom,
    dateTo: now,
    isShowUnclosed: true
  };

  return (
    <Formik
      onSubmit={values => {
        props.onSubmit(values, REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.TEAM_PERFORMANCE);
      }}
      initialValues={requestInitial}
    >
      {({ values, setFieldValue }) => (
        <Form className="eReportForm">
          <ReportDescription>
            Review the selected team’s performance over a period together with its upcoming fixture schedule.
          </ReportDescription>
          <ReportSection number={1} title="Reporting period" hint="Choose the date range covered by the report.">
            <ReportDateRange
              dateFrom={values.dateFrom}
              dateTo={values.dateTo}
              onChangeFrom={date => {
                setFieldValue('dateFrom', date);
                if (values.dateTo < date) setFieldValue('dateTo', date);
              }}
              onChangeTo={date => setFieldValue('dateTo', date)}
            />
          </ReportSection>
          <ReportSection
            number={2}
            title="Fixture status"
            hint="Choose whether scheduled and unfinished fixtures should appear."
          >
            <ReportToggleList>
              <ReportToggle
                name="isShowUnclosed"
                label="Show unclosed events"
                hint="Include events that have not yet been closed."
                value={values.isShowUnclosed}
                onChange={value => setFieldValue('isShowUnclosed', value)}
              />
            </ReportToggleList>
          </ReportSection>
          <ReportActions onCancel={props.onCloseClick} />
        </Form>
      )}
    </Formik>
  );
}
